import { render, staticRenderFns } from "./BaseInputArea.vue?vue&type=template&id=5fbef254&"
import script from "./BaseInputArea.vue?vue&type=script&lang=js&"
export * from "./BaseInputArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports